import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  TextField,
  DialogActions,
  Typography,
  ThemeProvider,
  createTheme,
  Box,
  Chip,
  Autocomplete,
  InputAdornment,
  Switch,
} from "@mui/material";

import { Edit, Trash2 } from "lucide-react";
import { TransitionProps } from "@mui/material/transitions";
import apiClient from "@lift-admin/utils/apiClient";
// import 'react-data-grid/lib/styles.css';
import { Toastify, Label, MultiSelectCheckboxTag } from 'lift-ui';
import { makeStyles } from "@mui/styles";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import DynamicNestedForm from "./params-input";
import { Info } from "lucide-react";
import BrandMultiSelect from "./brand-multiselect";
import { actionLog } from "../../../App";
import {
  buildDetails,
  buildSummary,
  diffFields,
  type FieldSpec,
} from "@lift-admin/utils/logChangeFormatter";
import {
  buildAccessListChange,
  resolveAccessEntryLabel,
} from "@/features/drawer-structure-v2/drawer-parts/accessLogHelpers";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const theme = createTheme({
  palette: {
    primary: {
      main: "#16306D",
    },
    secondary: {
      main: "rgba(0, 0, 0, 0)",
    },
  },
  typography: {
    fontFamily: '"Figtree", sans-serif',
  },
});
const useStyles = makeStyles({
  blockedRow: {
    backgroundColor: "#ffd8c7",
  },
});
interface ItemsProps {
  toggle: string;
  modules: any[];
  channels: any[];
  groupings: any[];
  component: any[];
  customComponents: any[];
  drawerItemsDynamic: any[];
  reports: any[];
  reportsSandbox: any[];
  openDialog: boolean;
  setOpenDialog: (value: boolean) => void;
  brands: any[];
  organizations: any[];
  searchText: string;
}

interface FormStateEdit {
  id: number | null;
  name: any | null;
  routeEndPoint: string | null;
  icon: string | null;

  selectedChannel: any | null;
  selectedModule: any | null;
  selectedGroupings: any | null;
  selectedUIComponents: any | null;
  selectedCustomComponents: any[];
  selectedReports: any[];
  levelAccess: string;
  selectedBrands: any[];
  selectedOrganizations: any[];
  params: any;
  selectedLevelId: [];
  reportType: string;
  isTeam: boolean;
  selectedSandbox: any | null;
  brands_exclude: [];
}

interface FormState {
  name: any | null;
  routeEndPoint: string | null;
  icon: string | null;

  selectedChannel: any | null;
  selectedModule: any | null;
  selectedGroupings: any | null;
  selectedUIComponents: any | null;
  selectedCustomComponents: any[];
  selectedReports: any[];
  levelAccess: string;
  selectedBrands: any[];
  selectedOrganizations: any[];
  params: any;
  selectedLevelId: [];
  reportType: string;
  isTeam: boolean;
  selectedSandbox: any | null;
  brands_exclude: [];
}

const initialFormStateEdit: FormStateEdit = {
  id: null,
  name: null,
  routeEndPoint: null,
  icon: null,

  selectedChannel: null,
  selectedModule: null,
  selectedGroupings: null,
  selectedUIComponents: null,
  selectedCustomComponents: [],
  selectedReports: [],
  levelAccess: "All",
  selectedBrands: [],
  selectedOrganizations: [],
  params: [],
  selectedLevelId: [],
  reportType: "Default",
  isTeam: false,
  selectedSandbox: null,
  brands_exclude: [],
};

const initialFormState: FormState = {
  name: null,
  routeEndPoint: null,
  icon: null,
  selectedChannel: null,
  selectedModule: null,
  selectedGroupings: null,
  selectedUIComponents: null,
  selectedCustomComponents: [],
  selectedReports: [],
  levelAccess: "All",
  selectedBrands: [],
  selectedOrganizations: [],
  params: [],
  selectedLevelId: [],
  reportType: "Default",
  isTeam: false,
  selectedSandbox: null,
  brands_exclude: [],
};

const Items = ({
  toggle,
  modules,
  channels,
  groupings,
  component,
  customComponents,
  drawerItemsDynamic,
  reports,
  reportsSandbox,
  openDialog,
  setOpenDialog,
  brands,
  organizations,
  searchText,
}: ItemsProps) => {
  const [loadData, setLoadData] = useState<boolean>(false);
  const [drawerItem, setDrawerItems] = useState<any>([]);
  const [drawerItemBackUp, setDrawerItemsBackUp] = useState<any>([]);
  const [formState, setFormState] = useState<FormState>(initialFormState);
  const [formStateEdit, setFormStateEdit] =
    useState<FormStateEdit>(initialFormStateEdit);
  const [openEditDialog, setOpenEditDialog] = useState<boolean>(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const [currentData, setCurrentData] = useState<any>(null);
  const [editTeamAcessCheck, setEditTeamAcessCheck] = useState<any>({
    cuurnet: null,
  });
  const [openTeamChangeDialog, setOpenTeamChangeDialog] =
    useState<boolean>(false);
  const [searchedResults, setSearchedResults] = useState<any>([]);

  const user = JSON.parse(localStorage.getItem("user") || "");
  const [existing, setExisting] = useState<any>(null);

  const handleFormChange = (field: keyof FormState, value: any) => {
    setFormState((prev) => {
      const newState = { ...prev, [field]: value };

      // Special handling for levelAccess changes
      if (field === "levelAccess") {
        newState.selectedBrands = [];
        newState.selectedOrganizations = [];
      }

      if (field === "selectedReports") {
        newState.selectedUIComponents = component.find(
          (sr: any) => sr?.name === "TableauWrapper"
        );
      }

      return newState;
    });
  };
  const handleFormEditChange = (field: keyof FormStateEdit, value: any) => {
    setFormStateEdit((prev) => {
      const newState = { ...prev, [field]: value };

      // Special handling for levelAccess changes
      if (field === "levelAccess") {
        newState.selectedBrands = [];
        newState.selectedOrganizations = [];
      }
      if (field === "selectedReports") {
        newState.selectedUIComponents = component.find(
          (sr: any) => sr?.name === "TableauWrapper"
        );
      }

      return newState;
    });
  };

  const getDrawerItems = async () => {
    setLoadData(true);
    try {
      const res = await apiClient.get(
        "/drawer/v1/admin/drawer/structure/drawer-items"
      );

      const sortedDrawerItems = res?.data?.response?.drawerItems.sort(
        (
          a: { created_at: string | number | Date },
          b: { created_at: string | number | Date }
        ) => {
          // Assuming created_at is in ISO 8601 format (e.g., "2024-12-17T14:52:29.000Z")
          return (
            (new Date(b.created_at) as any) - (new Date(a.created_at) as any)
          );
        }
      );

      if (searchText.trim().length === 0) {
        setDrawerItems(sortedDrawerItems);
      } else {
        setDrawerItems(
          sortedDrawerItems.filter((item: any) =>
            searchedResults.includes(item.id)
          )
        );
      }

      setDrawerItemsBackUp(sortedDrawerItems);
    } catch {
      Toastify("error", "Verticals not fetched");
    } finally {
      setLoadData(false);
    }
  };

  useEffect(() => {
    getDrawerItems();
  }, []);

  const channelMapping = channels?.reduce((acc, channel) => {
    acc[channel.id] = channel.name;
    return acc;
  }, {});
  const moduleMapping = modules?.reduce((acc, module) => {
    acc[module.id] = module.name;
    return acc;
  }, {});
  const groupingsMapping = groupings?.reduce((acc, grp) => {
    acc[grp.id] = grp.name;
    return acc;
  }, {});
  const componentMapping = component?.reduce((acc, comp) => {
    acc[comp.id] = comp.name;
    return acc;
  }, {});
  const customComponentsMapping = customComponents?.reduce((acc, cusComp) => {
    acc[cusComp.id] = cusComp.name;
    return acc;
  }, {});

  const reportsMapping = reports?.reduce((acc, report) => {
    acc[report.id] = report.display_name;
    return acc;
  }, {});
  const rowData = useMemo(() => drawerItem, [drawerItem]);

  const handleDelete = async (data: any) => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const res = await apiClient.delete(
        `/drawer/v1/admin/drawer/structure/drawer-item/${data?.id}`
      );

      getDrawerItems();
      setOpenDeleteDialog(false);
      Toastify("success", "Item Deleted successfully");

      const details: Array<{ label: string; value: string }> = [
        { label: "Item ID", value: String(data?.id ?? "Not Set") },
        {
          label: "Channel",
          value:
            channelMapping?.[data?.channel_id] ||
            channels?.find((c: any) => String(c.id) === String(data?.channel_id))
              ?.name ||
            String(data?.channel_id ?? "Not Set"),
        },
        {
          label: "Grouping",
          value: data?.grouping_id
            ? groupingsMapping?.[data.grouping_id] ||
              groupings?.find(
                (g: any) => String(g.id) === String(data.grouping_id)
              )?.name ||
              String(data.grouping_id)
            : "None",
        },
        {
          label: "UI Component",
          value:
            componentMapping?.[data?.ui_component_id] ||
            component?.find(
              (c: any) => String(c.id) === String(data?.ui_component_id)
            )?.name ||
            String(data?.ui_component_id ?? "Not Set"),
        },
      ];

      if ((data?.brands_exclude || []).length) {
        details.push({
          label: "Brand Access",
          value: (data.brands_exclude || [])
            .map((id: any) =>
              resolveAccessEntryLabel(id, brands || [], "Brand")
            )
            .join(", "),
        });
      }

      const desc = {
        message: buildSummary("Drawer item", data?.display_name, "deleted"),
        status: res.status,
        method: res.config.method,
        url: res.config.url,
        category: "drawer",
        action: "delete_item",
        item_id: data?.id,
        item_name: data?.display_name,
        user_id: user?.id,
        user_name: user?.name,
        details,
      };

      await actionLog?.actionLogTrack(JSON.stringify(desc), false);
    } catch (error: any) {
      Toastify("error", "Itens not deleted");
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const errorDesc = {
        message: `Failed to delete Drawer item (Item ID: ${data?.id ?? "N/A"}, Item Name: "${data?.display_name || ""}") by User (User ID: ${user?.id}, User Name: "${user?.name}")`,
        status: error?.response?.status,
        method: "DELETE",
        url: `/drawer/v1/admin/drawer/structure/drawer-item/${data?.id}`,
        category: "drawer",
        action: "delete_item",
        item_id: data?.id,
        item_name: data?.display_name,
        user_id: user?.id,
        user_name: user?.name,
      };
      await actionLog?.actionLogTrack(JSON.stringify(errorDesc), true);
    } finally {
      setCurrentData(null);
    }
  };

  const columnDefs = useMemo(
    () => [
      {
        field: "display_name",
        headerName: "Name",
        width: 250,
        sortable: true,
        resizable: true,
        editable: true,
        cellStyle: { display: "flex", alignItems: "center" },
      },
      {
        field: "report_type",
        headerName: "Report Type",
        width: 250,
        sortable: true,
        resizable: true,
        editable: true,
        cellStyle: { display: "flex", alignItems: "center" },
        cellEditor: "agSelectCellEditor", // Use agSelectCellEditor for dropdown
        cellEditorParams: {
          values: ["new", "existing", "default"], // Options for the dropdown
          // Removing checkbox behavior
          checkbox: false, // Make sure the editor doesn't use checkboxes
        },
      },

      {
        field: "level_access",
        headerName: "Level Access",
        width: 150,
        sortable: true,
        resizable: true,
        editable: true,
        cellStyle: { display: "flex", alignItems: "center" },
        cellEditor: "agSelectCellEditor", // Use agSelectCellEditor for dropdown
        cellEditorParams: {
          values: ["brand", "organization", "all"], // Options for the dropdown
          // Removing checkbox behavior
          checkbox: false, // Make sure the editor doesn't use checkboxes
        },
      },
      {
        field: "level_id",
        headerName: "Level IDs",
        width: 300,
        sortable: true,
        resizable: true,
        editable: true,
        cellStyle: { display: "flex", alignItems: "center" },
        valueGetter: (params: any) => {
          // if (Array.isArray(params?.data?.level_id)) {

          return params.data?.level_id
            .map((id: number) =>
              params.data?.level_access == "Brand"
                ? brands.find((b) => b.id == id)?.name
                : params.data?.level_access == "Organization"
                  ? organizations.find((b) => b.id == id)?.name
                  : ""
            )

            .filter(Boolean) // Filter out undefined values for unmatched IDs
            .join(", "); // Join names with a comma
          // }
          // return '';
        },
      },
      {
        field: "channel_id",
        headerName: "Channel",
        width: 300,
        sortable: true,
        resizable: true,
        editable: true,
        cellStyle: { display: "flex", alignItems: "center" },
        valueGetter: (params: any) =>
          channelMapping[params.data.channel_id] || "",
        filter: "agSetColumnFilter", // Adding a dropdown filter for channels
        filterParams: {
          values: Object.values(channelMapping), // Use channel names for filter options
          comparator: (a: string, b: string) => a.localeCompare(b), // Sort the dropdown options alphabetically
        },
      },
      {
        field: "module_id",
        headerName: "Module",
        width: 300,
        sortable: true,
        resizable: true,
        editable: true,
        cellStyle: { display: "flex", alignItems: "center" },
        valueGetter: (params: any) =>
          moduleMapping[params?.data?.module_id] || "",
      },
      {
        field: "grouping_id",
        headerName: "Grouping",
        width: 300,
        sortable: true,
        resizable: true,
        editable: true,
        cellStyle: { display: "flex", alignItems: "center" },
        valueGetter: (params: any) =>
          groupingsMapping[params?.data?.grouping_id] || "",
      },
      {
        field: "is_grouped",
        headerName: "Grouped",
        width: 300,
        sortable: true,
        resizable: true,
        editable: true,
        cellStyle: { display: "flex", alignItems: "center" },
        valueGetter: (params: any) => (params.data.is_grouped ? "Yes" : "No"),
      },

      {
        field: "is_team_access",
        headerName: "Team Access",
        width: 150,
        sortable: true,
        resizable: true,
        editable: true,
        cellStyle: { display: "flex", alignItems: "center" },
        valueGetter: (params: any) =>
          params.data.is_team_access ? "Yes" : "No",
      },

      {
        field: "ui_component_id",
        headerName: "Component",
        width: 300,
        sortable: true,
        resizable: true,
        editable: true,
        cellStyle: { display: "flex", alignItems: "center" },
        valueGetter: (params: any) =>
          componentMapping[params?.data?.ui_component_id] || "",
      },
      {
        field: "custom_component_id",
        headerName: "Custom Component",
        width: 300,
        sortable: true,
        resizable: true,
        editable: true,
        cellStyle: { display: "flex", alignItems: "center" },
        valueGetter: (params: any) => {
          if (Array.isArray(params?.data?.custom_component_id)) {
            return params.data.custom_component_id
              .map((id: number) => customComponentsMapping[id])
              .filter(Boolean) // Filter out undefined values for unmatched IDs
              .join(", "); // Join names with a comma
          }
          return "";
        },
      },
      {
        field: "report_id",
        headerName: "Reports",
        width: 300,
        sortable: true,
        resizable: true,
        editable: true,
        cellStyle: { display: "flex", alignItems: "center" },
        valueGetter: (params: any) => {
          if (Array.isArray(params?.data?.report_id)) {
            return params.data.report_id
              .map((id: number) => reportsMapping[id])
              .filter(Boolean) // Filter out undefined values for unmatched IDs
              .join(", "); // Join names with a comma
          }
          return "";
        },
      },

      {
        field: "route_endpoint",
        headerName: "Route Endpoint",
        width: 250,
        sortable: true,
        resizable: true,
        editable: true,
        cellStyle: { display: "flex", alignItems: "center" },
      },

      {
        field: "params",
        headerName: "Params",
        width: 250,
        sortable: true,
        resizable: true,
        editable: true,
        cellStyle: { display: "flex", alignItems: "center" },
        valueFormatter: (params: { value: any }) => {
          if (Array.isArray(params.value)) {
            return params.value.join(", ");
          }
          if (params?.value && typeof params.value === "object") {
            return Object.entries(params.value)
              .map(([key, val]) => `${key}: ${val}`)
              .join(", ");
          }
          return "";
        },
        cellEditor: "agLargeTextCellEditor", // Optional: for better object editing
        cellEditorParams: {
          maxLength: 500,
          rows: 5,
          cols: 50,
        },
      },

      {
        field: "user",
        headerName: "Updated By",
        width: 250,
        sortable: true,
        resizable: true,
        editable: true,
        cellStyle: { display: "flex", alignItems: "center" },
        valueGetter: (params: any) => params?.data?.user?.name || "",
      },
      {
        field: "actions", // New column for actions
        headerName: "Actions",
        width: 150,
        sortable: false,
        resizable: false,
        editable: false,
        pinned: "right" as const,
        headerClass: "center-header",
        cellStyle: { display: "flex", alignItems: "center" },
        cellRenderer: (params: { data: any }) => {
          return (
            <div style={{ display: "flex", gap: "5px" }}>
              <Button
                onClick={() => {
                  handleEditOpen(params?.data)
                  setCurrentData(params?.data)
                }} // Handle edit action
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <Edit className="h-4 w-4" />
              </Button>
              <Button
                onClick={() => {
                  setOpenDeleteDialog(true);
                  setCurrentData(params?.data);
                }} // Handle delete action
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <Trash2 className="h-4 w-4 text-red-600" />
              </Button>
            </div>
          );
        },
      },
    ],
    [
      channels,
      modules,
      component,
      groupings,
      customComponents,
      reports,
      brands,
      organizations,
    ]
  );

  const defaultColDef = {
    resizable: true,
    sortable: true,
    editable: false, // Can be overridden per column
  };
  // const rowData = drawerStructure; // Assuming `paginatedList` is your data array

  const onCellValueChanged = (event: any) => {
    // setChangedValue(event.data); // Store the changed row data
  };

  const handleButtonClick = () => {
    setOpenDialog(true);
  };

  const handleAddDrawerItem = async () => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    try {
      if (formState.reportType === "Existing") {
        if (
          existing &&
          existing?.report_id?.length !== formState.selectedReports.length
        ) {
          Toastify(
            "error",
            "Please select same number of reports just like the existing report"
          );
          return;
        }
      }

      const payload = {
        channel_id: formState.selectedChannel?.id,
        module_id: formState.selectedModule?.id,
        grouping_id: formState.selectedGroupings?.id,
        display_name:
          formState.reportType === "Existing"
            ? formState?.name?.display_name
            : formState?.name,
        level_id:
          formState.levelAccess === "Brand"
            ? formState.selectedBrands.map((b) => b.id)
            : formState.levelAccess === "Organization"
              ? formState.selectedOrganizations.map((o) => o.id)
              : [],
        icon: formState.icon,
        route_endpoint: createEndPoint(formState) + formState.routeEndPoint,
        is_team_access: formState.isTeam,
        is_grouped: formState.selectedGroupings?.id ? true : false,
        ui_component_id: formState.selectedUIComponents?.id,
        custom_component_id:
          formState.selectedUIComponents?.name == "SuperComponent"
            ? formState.selectedCustomComponents?.map(
              (component: { id: any }) => component.id
            )
            : [],
        report_id: formState.selectedReports.map((report) => report.id),
        level_access: formState.levelAccess,
        params:
          formState.selectedUIComponents?.name == "SuperComponent"
            ? transformData(formState.params)
            : Array.isArray(formState.params)
              ? formState.params.toString().split(",").map(Number)
              : formState.params.split(",").map(Number),
        report_type: formState.reportType,
        updated_by: user.id,
        sandbox_id: formState.selectedSandbox?.id
          ? formState.selectedSandbox?.id
          : null,
        brands_exclude:
          formState.reportType === "Default" ? formState.brands_exclude : [],
      };

      const res = await apiClient.post(
        "/drawer/v1/admin/drawer/structure/drawer-item",
        payload
      );

      getDrawerItems();
      handleDialogClose();

      const createFieldSpecs: FieldSpec[] = [
        { key: "display_name", label: "Display Name" },
        {
          key: "channel_id",
          label: "Channel",
          resolve: (id) =>
            channelMapping?.[id] ||
            channels?.find((c: any) => String(c.id) === String(id))?.name ||
            (id ? String(id) : "Not Set"),
        },
        {
          key: "module_id",
          label: "Module",
          resolve: (id) =>
            moduleMapping?.[id] ||
            modules?.find((m: any) => String(m.id) === String(id))?.name ||
            (id ? String(id) : "Not Set"),
        },
        {
          key: "grouping_id",
          label: "Grouping",
          resolve: (id) =>
            id
              ? groupingsMapping?.[id] ||
                groupings?.find((g: any) => String(g.id) === String(id))
                  ?.name ||
                String(id)
              : "None",
        },
        {
          key: "ui_component_id",
          label: "UI Component",
          resolve: (id) =>
            componentMapping?.[id] ||
            component?.find((c: any) => String(c.id) === String(id))?.name ||
            (id ? String(id) : "Not Set"),
        },
        { key: "route_endpoint", label: "Route" },
        { key: "report_type", label: "Report Type" },
        { key: "level_access", label: "Level Access" },
        {
          key: "report_id",
          label: "Reports",
          type: "list",
          resolve: (id) =>
            reportsMapping?.[id] ||
            reportsSandbox?.find((r: any) => String(r.id) === String(id))
              ?.display_name ||
            (id ? String(id) : "Not Set"),
        },
        {
          key: "custom_component_id",
          label: "Custom Components",
          type: "list",
          resolve: (id) =>
            customComponentsMapping?.[id] || (id ? String(id) : "Not Set"),
        },
      ];
      const desc = {
        message: buildSummary("Drawer item", payload?.display_name, "created"),
        status: res.status,
        method: res.config.method,
        url: res.config.url,
        category: "drawer",
        action: "create_item",
        item_name: payload?.display_name,
        user_id: user?.id,
        user_name: user?.name,
        details: [
          ...buildDetails(payload, createFieldSpecs, { skipEmpty: true }),
          ...(formState.reportType === "Default" &&
          (payload.brands_exclude || []).length
            ? [
                {
                  label: "Brand Access",
                  value: (payload.brands_exclude || [])
                    .map((id: any) =>
                      resolveAccessEntryLabel(id, brands || [], "Brand")
                    )
                    .join(", "),
                },
              ]
            : []),
        ],
      };

      await actionLog?.actionLogTrack(JSON.stringify(desc), false);
    } catch (err: any) {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const itemName = formState.reportType === "Existing"
        ? formState?.name?.display_name
        : formState?.name;
      if (err.response.data.errors) {
        Toastify(
          "error",
          `${err.response.data.errors[0].path}: ${err.response.data.errors[0].message}`
        );
        const errorDesc = {
          message: `Failed to add drawer item (Item Name: "${itemName}") by User (User ID: ${user?.id}, User Name: "${user?.name}"). Error: ${err.response.data.errors[0].message}`,
          status: err.response?.status,
          method: "POST",
          url: "/drawer/v1/admin/drawer/structure/drawer-item",
          category: "drawer",
          action: "create_item",
          item_name: itemName,
          user_id: user?.id,
          user_name: user?.name,
        };
        await actionLog?.actionLogTrack(JSON.stringify(errorDesc), true);
      } else {
        Toastify("error", err.response.data.message);
        const errorDesc = {
          message: `Failed to add drawer item (Item Name: "${itemName}") by User (User ID: ${user?.id}, User Name: "${user?.name}"). Error: ${err.response.data.message}`,
          status: err.response?.status,
          method: "POST",
          url: "/drawer/v1/admin/drawer/structure/drawer-item",
          category: "drawer",
          action: "create_item",
          item_name: itemName,
          user_id: user?.id,
          user_name: user?.name,
        };
        await actionLog?.actionLogTrack(JSON.stringify(errorDesc), true);
      }
    }
  };

  const pascalCaseRegex = /^[A-Z][a-zA-Z0-9]*$/;
  const kebabCaseRegex = /^[a-z0-9]+(-[a-z0-9]+)*$/;

  const validateForm = (formData: any) => {
    const newErrors = {
      name: "",
      icon: "",
      routeEndPoint: "",
    };
    let isValid = true;

    // Name validation
    if (!formData.name) {
      newErrors.name = "Name is required";
      Toastify("error", "Please enter a name");
      isValid = false;
    }

    // Route endpoint validation (kebab-case)

    if (formData.routeEndPoint) {
      if (!kebabCaseRegex.test(formData.routeEndPoint)) {
        newErrors.routeEndPoint = "Route endpoint should be in kebab-case";
        Toastify(
          "error",
          "Route endpoint must be in kebab-case format (e.g., my-route)"
        );
        isValid = false;
      }
    } else {
      newErrors.routeEndPoint = "Route endpoint is required";
      Toastify("error", "Please enter a route endpoint");
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = () => {
    if (!validateForm(formState)) {
      return;
    }

    // Additional required field validations
    if (!formState.selectedChannel) {
      Toastify("error", "Please select a channel");
      return;
    }

    if (!formState.selectedModule) {
      Toastify("error", "Please select a module");
      return;
    }

    console.log(formState, "formState-formState");
    if (!formState.selectedUIComponents) {
      Toastify("error", "Please select a UI component");
      return;
    }

    if (
      formState.levelAccess === "Brand" &&
      formState.selectedBrands.length === 0
    ) {
      Toastify(
        "error",
        "Please select at least one brand for Brand level access"
      );
      return;
    }

    if (
      formState.levelAccess === "Organization" &&
      formState.selectedOrganizations.length === 0
    ) {
      Toastify(
        "error",
        "Please select at least one organization for Organization level access"
      );
      return;
    }

    handleAddDrawerItem();
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setFormState(initialFormState);
    setExisting(null);
  };

  const handleEditDialogClose = () => {
    setOpenEditDialog(false);
    setFormStateEdit(initialFormStateEdit);
    setExisting(null);
    setCurrentData(null);
  };

  const transformData = (data: any) => {
    const result: Record<string, string> = {};

    data.forEach((section: any) => {
      const prefix = `ds${section.number}`;
      section.items.forEach((item: any) => {
        result[`${prefix}.${item.report}`] = item.hash;
      });
    });

    return result;
  };

  const handleEditOpen = (itemData: any) => {
    console.log(itemData, "itemData-itemData");

    const routeEndPointLen = itemData.route_endpoint.split("/").length;
    const routeEndPoint =
      itemData.route_endpoint.split("/")[routeEndPointLen - 1];

    const formStateEditFinal: FormStateEdit = {
      id: itemData.id,
      name:
        itemData.report_type !== "Existing" ? itemData?.display_name : itemData,
      routeEndPoint: routeEndPoint,
      params: Array.isArray(itemData.params)
        ? itemData.params?.toString()
        : itemData.params,
      icon: itemData.icon,
      selectedChannel:
        channels.find((ch) => ch.id === itemData.channel_id) || null,
      selectedModule: modules.find((m) => m.id === itemData.module_id) || null,
      selectedGroupings:
        groupings.find((g) => g.id === itemData.grouping_id) || null,
      selectedUIComponents:
        component.find((c) => c.id === itemData.ui_component_id) || null,
      selectedCustomComponents: itemData.custom_component_id
        ? customComponents.filter((cc) =>
          itemData.custom_component_id.includes(cc.id)
        )
        : [],
      selectedReports: itemData.report_id
        ? itemData.report_id.map((id: any) =>
          reports.find((report) => report.id == id)
        )
        : [],
      levelAccess: itemData.level_access || "All",
      selectedBrands:
        itemData.level_access === "Brand"
          ? brands.filter((b) => itemData.level_id.includes(b.id))
          : [],
      selectedOrganizations:
        itemData.level_access === "Organization"
          ? organizations.filter((o) => itemData.level_id.includes(o.id))
          : [],
      selectedLevelId: itemData.level_id,
      reportType: itemData.report_type,
      isTeam: itemData.is_team_access,
      selectedSandbox: reportsSandbox.find((r) => r.id === itemData.sandbox_id),
      brands_exclude:
        itemData.report_type === "Default" ? itemData.brands_exclude : [],
    };

    setEditTeamAcessCheck({
      current: itemData.is_team_access,
    });
    setFormStateEdit(formStateEditFinal);
    setOpenEditDialog(true);
  };

  const handleEditSubmit = async () => {
    try {
      if (!validateForm(formStateEdit)) {
        return;
      }

      // Additional required field validations
      if (!formStateEdit.selectedChannel) {
        Toastify("error", "Please select a channel");
        return;
      }

      if (!formStateEdit.selectedModule) {
        Toastify("error", "Please select a module");
        return;
      }

      if (!formStateEdit.selectedUIComponents) {
        Toastify("error", "Please select a UI component");
        return;
      }

      if (
        formStateEdit.levelAccess === "Brand" &&
        formStateEdit.selectedBrands.length === 0
      ) {
        Toastify(
          "error",
          "Please select at least one brand for Brand level access"
        );
        return;
      }

      if (
        formStateEdit.levelAccess === "Organization" &&
        formStateEdit.selectedOrganizations.length === 0
      ) {
        Toastify(
          "error",
          "Please select at least one organization for Organization level access"
        );
        return;
      }

      const payload = {
        channel_id: formStateEdit.selectedChannel?.id,
        module_id: formStateEdit.selectedModule?.id,
        grouping_id: formStateEdit.selectedGroupings?.id,
        display_name:
          formStateEdit.reportType === "Existing"
            ? formStateEdit?.name?.display_name
            : formStateEdit?.name,

        level_id:
          formStateEdit.levelAccess === "Brand"
            ? formStateEdit.selectedBrands.map((b) => b.id)
            : formStateEdit.levelAccess === "Organization"
              ? formStateEdit.selectedOrganizations.map((o) => o.id)
              : [],
        icon: formStateEdit.icon,
        route_endpoint:
          createEndPoint(formStateEdit) + formStateEdit.routeEndPoint,
        is_team_access: formStateEdit.isTeam,
        is_grouped: formStateEdit.selectedGroupings?.id ? true : false,
        ui_component_id: formStateEdit.selectedUIComponents?.id,
        custom_component_id:
          formStateEdit.selectedUIComponents?.name == "SuperComponent"
            ? formStateEdit.selectedCustomComponents?.map(
              (component: { id: any }) => component.id
            )
            : [],
        report_id: formStateEdit.selectedReports.map((report) => report.id),
        level_access: formStateEdit.levelAccess,
        params:
          formStateEdit.selectedUIComponents?.name === "SuperComponent"
            ? transformData(formStateEdit.params)
            : Array.isArray(formStateEdit.params)
              ? formStateEdit.params.toString().split(",").map(Number)
              : formStateEdit.params.split(",").map(Number),
        report_type: formStateEdit.reportType,
        updated_by: user.id,
        sandbox_id: formStateEdit?.selectedSandbox?.id
          ? formStateEdit?.selectedSandbox?.id
          : null,

        brands_exclude:
          formStateEdit.reportType === "Default"
            ? formStateEdit.brands_exclude
            : [],
      };

      // return;
      const res = await apiClient.put(
        `/drawer/v1/admin/drawer/structure/drawer-item/${formStateEdit.id}`,
        payload
      );
      getDrawerItems();
      handleEditDialogClose();
      Toastify("success", "Item updated successfully");
      const itemFieldSpecs: FieldSpec[] = [
        { key: "display_name", label: "Display Name" },
        {
          key: "channel_id",
          label: "Channel",
          resolve: (id) =>
            channelMapping?.[id] ||
            channels?.find((c: any) => String(c.id) === String(id))?.name ||
            (id ? String(id) : "Not Set"),
        },
        {
          key: "module_id",
          label: "Module",
          resolve: (id) =>
            moduleMapping?.[id] ||
            modules?.find((m: any) => String(m.id) === String(id))?.name ||
            (id ? String(id) : "Not Set"),
        },
        {
          key: "grouping_id",
          label: "Grouping",
          resolve: (id) =>
            id
              ? groupingsMapping?.[id] ||
                groupings?.find((g: any) => String(g.id) === String(id))
                  ?.name ||
                String(id)
              : "None",
        },
        {
          key: "ui_component_id",
          label: "UI Component",
          resolve: (id) =>
            componentMapping?.[id] ||
            component?.find((c: any) => String(c.id) === String(id))?.name ||
            (id ? String(id) : "Not Set"),
        },
        { key: "route_endpoint", label: "Route" },
        { key: "icon", label: "Icon" },
        {
          key: "is_team_access",
          label: "Team Access",
          type: "boolean",
          boolStyle: "yesNo",
        },
        { key: "report_type", label: "Report Type" },
        { key: "level_access", label: "Level Access" },
        {
          key: "report_id",
          label: "Reports",
          type: "list",
          resolve: (id) =>
            reportsMapping?.[id] ||
            reportsSandbox?.find((r: any) => String(r.id) === String(id))
              ?.display_name ||
            (id ? String(id) : "Not Set"),
        },
        {
          key: "custom_component_id",
          label: "Custom Components",
          type: "list",
          resolve: (id) =>
            customComponentsMapping?.[id] ||
            customComponents?.find((c: any) => String(c.id) === String(id))
              ?.name ||
            (id ? String(id) : "Not Set"),
        },
        {
          key: "sandbox_id",
          label: "Sandbox Report",
          resolve: (id) =>
            reportsSandbox?.find((r: any) => String(r.id) === String(id))
              ?.display_name ||
            (id ? String(id) : "Not Set"),
        },
      ];

      const previousItem = {
        display_name: currentData?.display_name,
        channel_id: currentData?.channel_id,
        module_id: currentData?.module_id,
        grouping_id: currentData?.grouping_id || null,
        ui_component_id: currentData?.ui_component_id,
        route_endpoint: currentData?.route_endpoint,
        icon: currentData?.icon || null,
        is_team_access: currentData?.is_team_access,
        report_type: currentData?.report_type,
        level_access: currentData?.level_access,
        report_id: currentData?.report_id || [],
        custom_component_id: currentData?.custom_component_id || [],
        sandbox_id: currentData?.sandbox_id || null,
      };

      const nextItem = {
        display_name: payload.display_name,
        channel_id: payload.channel_id,
        module_id: payload.module_id,
        grouping_id: payload.grouping_id || null,
        ui_component_id: payload.ui_component_id,
        route_endpoint: payload.route_endpoint,
        icon: payload.icon || null,
        is_team_access: payload.is_team_access,
        report_type: payload.report_type,
        level_access: payload.level_access,
        report_id: payload.report_id || [],
        custom_component_id: payload.custom_component_id || [],
        sandbox_id: payload.sandbox_id || null,
      };

      const changes = diffFields(previousItem, nextItem, itemFieldSpecs);
      if (formStateEdit.reportType === "Default") {
        const brandChange = buildAccessListChange(
          "Brand Access",
          currentData?.brands_exclude || [],
          payload.brands_exclude || [],
          brands || [],
          "Brand"
        );
        if (brandChange) changes.push(brandChange);
      }
      const desc = {
        message: buildSummary(
          "Drawer item",
          payload?.display_name || currentData?.display_name,
          "updated",
          changes.length
        ),
        status: res.status,
        method: res.config.method,
        url: res.config.url,
        category: "drawer",
        action: "update_item",
        item_id: formStateEdit.id,
        item_name: payload?.display_name,
        changes,
      };
      setCurrentData(null);
      await actionLog?.actionLogTrack(JSON.stringify(desc), false);
    } catch (err: any) {
      console.error(err);
      Toastify("error", "Failed to update item");
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const errorDesc = {
        message: `Failed to update Drawer item (Item ID: ${formStateEdit.id ?? "N/A"}, Item Name: "${formStateEdit.name || currentData?.display_name || ""}") by User (User ID: ${user?.id}, User Name: "${user?.name}")`,
        status: err?.response?.status,
        method: "PUT",
        url: `/drawer/v1/admin/drawer/structure/drawer-item/${formStateEdit.id}`,
        category: "drawer",
        action: "update_item",
        item_id: formStateEdit.id,
        item_name: formStateEdit.name || currentData?.display_name,
        user_id: user?.id,
        user_name: user?.name,
      };
      await actionLog?.actionLogTrack(JSON.stringify(errorDesc), true);
    }
  };

  const createEndPoint = (state: any) => {
    let endPointPath = "";

    if (state.selectedChannel?.id) {
      endPointPath += ``;
      if (state.selectedChannel?.name) {
        const channelPath = state.selectedChannel.name
          .toLowerCase()
          .replace(/\s+/g, "-");
        endPointPath += `/${channelPath}`;
      }
    }

    if (state.selectedModule?.id) {
      if (state.selectedModule?.name) {
        const modulePath = state.selectedModule.name
          .toLowerCase()
          .replace(/\s+/g, "-");
        endPointPath += `/${modulePath}`;
      }
    }

    if (state.selectedGroupings) {
      endPointPath += `/${state.selectedGroupings.path}`;
    }

    endPointPath += `/`;

    return endPointPath;
  };

  const searchResults = (query: any) => {
    const filteredUsers = [...drawerItemBackUp];
    let results = [];
    for (let i = 0; i < filteredUsers.length; i++) {
      if (
        filteredUsers[i]["display_name"]
          ?.toLowerCase()
          .includes(query.toLowerCase()) ||
        filteredUsers[i]["route_endpoint"]
          ?.toLowerCase()
          .includes(query.toLowerCase())
      )
        results.push(filteredUsers[i]);
    }

    setDrawerItems(results);
    setSearchedResults(results.map((item: any) => item.id));
  };

  useEffect(() => {
    searchResults(searchText);
  }, [searchText]);

  const [defaultBrands, setDefaultBrands] = useState([]);

  console.log(currentData, "currentData");
  return (
    <>
      <ThemeProvider theme={theme}>
        <Paper
          className="table-paper item-table"
          sx={{
            paddingLeft: 0,
            // display: 'flex',
            // flexDirection: 'column',
            // alignItems: 'flex-end',
            // background: 'transparent',
          }}
        >
          <div
            className="ag-theme-alpine"
            style={{ height: "100%", width: "100%" }}
          >
            <AgGridReact
              columnDefs={columnDefs.map((colDef) => ({
                ...colDef,
                editable: false,
              }))}
              rowData={rowData}
              defaultColDef={defaultColDef}
              rowHeight={80}
              onCellValueChanged={onCellValueChanged}
              pagination={true}
              paginationPageSize={20}
              suppressPaginationPanel={false}
            />
          </div>
        </Paper>
        <Dialog
          open={openDeleteDialog}
          onClose={() => setOpenDeleteDialog(false)}
        >
          <DialogTitle>Are you sure you want to delete?</DialogTitle>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenDeleteDialog(false);
                setCurrentData(null);
              }}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                handleDelete(currentData);
              }}
              color="primary"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openDialog} onClose={handleDialogClose}>
          <DialogTitle>
            Add New Item
            <Box sx={{ position: "absolute", right: 10, top: 10 }}>
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="body1">Team Access</Typography>
                <Switch
                  checked={formState.isTeam}
                  onChange={(event) =>
                    setFormState((prev) => ({
                      ...prev,
                      isTeam: event.target.checked,
                    }))
                  }
                />
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent style={{ padding: "10px" }}>
            {formState.reportType === "Default" && (
              <BrandMultiSelect
                defaultBrands={formState.brands_exclude}
                setDefaultBrands={handleFormChange}
              />
            )}

            <Autocomplete
              options={["Default", "New", "Existing"]}
              value={formState.reportType}
              getOptionLabel={(option) => option}
              onChange={(event, value) => {
                handleFormChange("reportType", value);
                if (value === "Existing") {
                  handleFormChange("name", null);
                } else {
                  handleFormChange("name", "");
                }

                if (value === "Default") {
                  handleFormChange("levelAccess", "All");
                } else {
                  handleFormChange("levelAccess", "Brand");
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Report Type"
                  fullWidth
                  style={{ marginBottom: "16px" }}
                />
              )}
            />
            {formState.reportType != "Existing" ? (
              <TextField
                label="Name"
                value={formState.name}
                onChange={(e) => {
                  handleFormChange("name", e.target.value);
                  handleFormChange(
                    "routeEndPoint",
                    e.target.value.toLowerCase().replace(/\s+/g, "-")
                  );
                }}
                fullWidth
                style={{ marginBottom: "16px" }}
              />
            ) : (
              <Autocomplete
                options={drawerItemBackUp}
                value={formState.name}
                getOptionLabel={(option: any) => option.display_name}
                onChange={(_, value: any) => {
                  const item = rowData.find(
                    (item: any) => item.id === value.id
                  );
                  const channel = channels.find(
                    (ch) => ch.id === item.channel_id
                  );
                  const module = modules.find((ch) => ch.id === item.module_id);

                  const customComponent = customComponents.filter((ch) =>
                    item.custom_component_id.includes(ch.id)
                  );
                  const compo = component.find(
                    (ch) => ch.id === item.ui_component_id
                  );

                  const grouping = groupings.find(
                    (ch) => ch.id === item.grouping_id
                  );

                  handleFormChange("name", value);
                  handleFormChange("selectedModule", module);
                  handleFormChange("selectedChannel", channel);
                  handleFormChange("selectedModule", module);
                  if (grouping) handleFormChange("selectedGroupings", grouping);
                  handleFormChange("selectedUIComponents", compo);
                  handleFormChange("selectedCustomComponents", customComponent);
                  handleFormChange("params", item?.params.toString());
                  setFormState((prev: any) => ({
                    ...prev,
                    isTeam: item?.is_team_access,
                  }));

                  setExisting(item);
                  const routeEndPointLen =
                    item.route_endpoint.split("/").length;
                  const routeEndPoint =
                    item.route_endpoint.split("/")[routeEndPointLen - 1];

                  handleFormChange("routeEndPoint", routeEndPoint);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Name"
                    fullWidth
                    style={{ marginBottom: "16px" }}
                  />
                )}
              />
            )}
            <Autocomplete
              options={
                formState.reportType === "Default"
                  ? ["All"]
                  : ["Brand", "Organization"]
              }
              value={formState.levelAccess}
              getOptionLabel={(option) => option}
              onChange={(event, value) => {
                handleFormChange("levelAccess", value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Level Access"
                  fullWidth
                  style={{ marginBottom: "16px" }}
                />
              )}
            />
            {formState.levelAccess === "Brand" && (
              <Autocomplete
                multiple
                options={brands}
                getOptionLabel={(option) => option.name}
                value={formState.selectedBrands}
                onChange={(event, newValue) => {
                  handleFormChange("selectedBrands", newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Level Access Brands"
                    fullWidth
                    style={{ marginBottom: "16px" }}
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      label={option.name}
                      {...getTagProps({ index })}
                      style={{ margin: "2px" }}
                    />
                  ))
                }
              />
            )}
            {/* Show Organizations dropdown if level access is 'organization' */}
            {formState.levelAccess === "Organization" && (
              <Autocomplete
                multiple
                value={formState.selectedOrganizations}
                options={organizations}
                getOptionLabel={(option) => option.name}
                onChange={(event, newValue) =>
                  handleFormChange("selectedOrganizations", newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Level Access Organizations"
                    fullWidth
                    style={{ marginBottom: "16px" }}
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      label={option.name}
                      {...getTagProps({ index })}
                      style={{ margin: "2px" }}
                    />
                  ))
                }
              />
            )}

            <Autocomplete
              disabled={formState.reportType === "Existing"}
              options={channels}
              getOptionLabel={(option) => option.name}
              onChange={(event, value) => {
                handleFormChange("selectedChannel", value);
              }}
              value={formState.selectedChannel}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Channel Name"
                  fullWidth
                  style={{ marginBottom: "16px" }}
                />
              )}
            />

            <Autocomplete
              options={modules}
              disabled={formState.reportType === "Existing"}
              getOptionLabel={(option) => option.name}
              onChange={(event, value) =>
                handleFormChange("selectedModule", value)
              }
              value={formState.selectedModule}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Module Name"
                  fullWidth
                  style={{ marginBottom: "16px" }}
                />
              )}
            />
            <Autocomplete
              disabled={formState.reportType === "Existing"}
              options={groupings.filter((g) =>
                formState.selectedChannel
                  ? g.channel_id === formState.selectedChannel.id
                  : g
              )}
              value={formState.selectedGroupings}
              getOptionLabel={(option) =>
                `${option.name}  (${channelMapping[option.channel_id]})`
              }
              onChange={(event, value) =>
                handleFormChange("selectedGroupings", value)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Grouping Name"
                  fullWidth
                  style={{ marginBottom: "16px" }}
                />
              )}
            />

            <Autocomplete
              options={component}
              disabled={
                !!formState.selectedReports?.find((sr: any) =>
                  sr?.embeded_url?.includes("tableau.com")
                )
              }
              value={formState.selectedUIComponents}
              getOptionLabel={(option) => option.name}
              onChange={(event, value) =>
                handleFormChange("selectedUIComponents", value)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select UI Component Name"
                  fullWidth
                  style={{ marginBottom: "16px" }}
                />
              )}
            />

            {formState.selectedUIComponents?.name == "SuperComponent" && (
              <Autocomplete
                disabled={formState.reportType === "Existing"}
                multiple
                options={customComponents}
                value={formState.selectedCustomComponents}
                getOptionLabel={(option) => option.name}
                onChange={(event, value) =>
                  handleFormChange("selectedCustomComponents", value)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Custom Component Name"
                    fullWidth
                    style={{ marginBottom: "16px" }}
                  />
                )}
              />
            )}

            <Box
              display="flex"
              justifyContent="flex-start"
              alignItems="center"
              style={{ marginBottom: "8px", marginTop: "8px" }}
            >
              <Info className="info-icon " fontSize="small" />
              <Typography
                variant="body2"
                color="textSecondary"
                style={{
                  marginLeft: 5,
                }}
              >
                If you want multiple reports, contact support.
              </Typography>
            </Box>

            <Label className="block mb-2">Select Report</Label>
            <MultiSelectCheckboxTag
              placeholder="Select reports"
              options={(reports || []).map((r: any) => ({ label: r?.display_name || String(r?.id ?? ''), value: String(r.id) }))}
              value={(formState.selectedReports || []).map((r: any) => String(r.id))}
              onChange={(ids: string[]) =>
                handleFormChange(
                  "selectedReports",
                  ids.map((id: string) => reports.find((r: any) => String(r.id) === id)).filter(Boolean) as any[]
                )
              }
              containerClassName="w-full"
              showSelectAll
            />

            <Autocomplete
              disabled={
                formState.reportType === "Existing" ||
                formState.selectedReports?.find((sr: any) =>
                  sr?.embeded_url?.includes("tableau.com")
                )
              }
              options={reportsSandbox}
              value={formState.selectedSandbox}
              getOptionLabel={(option) => option.display_name}
              onChange={(event, value) => {
                handleFormChange("selectedSandbox", value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Sandbox"
                  fullWidth
                  style={{ marginBottom: "16px" }}
                />
              )}
            />
            <TextField
              disabled={formState.reportType === "Existing"}
              label="Route Endpoint"
              value={formState.routeEndPoint}
              onChange={(e) =>
                handleFormChange("routeEndPoint", e.target.value)
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {createEndPoint(formState)}
                  </InputAdornment>
                ),
              }}
              fullWidth
              style={{ marginBottom: "16px" }}
            />

            {formState.selectedUIComponents?.name != "SuperComponent" ? (
              <TextField
                label="Params"
                disabled={
                  formState.reportType === "Existing" ||
                  !!formState.selectedReports?.find((sr: any) =>
                    sr?.embeded_url?.includes("tableau.com")
                  )
                }
                value={formState.params}
                onChange={(e) => handleFormChange("params", e.target.value)}
                fullWidth
                style={{ marginBottom: "16px" }}
              />
            ) : (
              <DynamicNestedForm
                formStateEdit={formState}
                handleFormEditChange={handleFormChange}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSubmit} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openEditDialog} onClose={handleEditDialogClose}>
          <DialogTitle>
            Edit Item
            <Box sx={{ position: "absolute", right: 10, top: 10 }}>
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="body1">Team Access</Typography>
                <Switch
                  checked={formStateEdit.isTeam}
                  onChange={(event) => {
                    if (
                      event.target.checked !== editTeamAcessCheck.current &&
                      formStateEdit.selectedGroupings
                    ) {
                      setOpenTeamChangeDialog(true);

                      return;
                    }
                    setFormStateEdit((prev: any) => ({
                      ...prev,
                      isTeam: event.target.checked,
                    }));
                  }}
                />
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent style={{ padding: "10px" }}>
            {formStateEdit.reportType === "Default" && (
              <BrandMultiSelect
                defaultBrands={formStateEdit.brands_exclude}
                setDefaultBrands={handleFormEditChange}
              />
            )}
            <Autocomplete
              options={["Default", "New", "Existing"]}
              value={formStateEdit.reportType}
              getOptionLabel={(option) => option}
              onChange={(event, value) => {
                handleFormEditChange("reportType", value);

                if (value === "Existing") {
                  handleFormEditChange("name", null);
                } else {
                  handleFormEditChange("name", "");
                }

                if (value === "Default") {
                  handleFormEditChange("levelAccess", "All");
                } else {
                  handleFormEditChange("levelAccess", "Brand");
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Report Type"
                  fullWidth
                  style={{ marginBottom: "16px" }}
                />
              )}
            />

            {formStateEdit.reportType != "Existing" ? (
              <TextField
                label="Name"
                value={formStateEdit.name}
                onChange={(e) => {
                  handleFormEditChange("name", e.target.value);
                  handleFormEditChange(
                    "routeEndPoint",
                    e.target.value.toLowerCase().replace(/\s+/g, "-")
                  );
                }}
                fullWidth
                style={{ marginBottom: "16px" }}
              />
            ) : (
              <Autocomplete
                options={drawerItemBackUp}
                value={formStateEdit.name}
                getOptionLabel={(option: any) => option.display_name}
                onChange={(_, value: any) => {
                  const item = rowData.find(
                    (item: any) => item.id === value.id
                  );
                  const channel = channels.find(
                    (ch) => ch.id === item.channel_id
                  );
                  const module = modules.find((ch) => ch.id === item.module_id);

                  const customComponent = customComponents.filter((ch) =>
                    item.custom_component_id.includes(ch.id)
                  );
                  const compo = component.find(
                    (ch) => ch.id === item.ui_component_id
                  );

                  const grouping = groupings.find(
                    (ch) => ch.id === item.grouping_id
                  );

                  handleFormEditChange("name", value);
                  handleFormEditChange("selectedModule", module);
                  handleFormEditChange("selectedChannel", channel);
                  handleFormEditChange("selectedModule", module);
                  if (grouping)
                    handleFormEditChange("selectedGroupings", grouping);
                  handleFormEditChange("selectedUIComponents", compo);
                  handleFormEditChange(
                    "selectedCustomComponents",
                    customComponent
                  );

                  handleFormEditChange("params", item?.params.toString());
                  setFormStateEdit((prev: any) => ({
                    ...prev,
                    isTeam: item?.is_team_access,
                  }));

                  setExisting(item);
                  handleFormEditChange(
                    "routeEndPoint",
                    value?.display_name
                      ? value?.display_name?.toLowerCase().replace(/\s+/g, "-")
                      : value
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Name"
                    fullWidth
                    style={{ marginBottom: "16px" }}
                  />
                )}
              />
            )}

            <Autocomplete
              options={
                formStateEdit.reportType == "Default"
                  ? ["All"]
                  : ["Brand", "Organization"]
              }
              value={formStateEdit.levelAccess}
              getOptionLabel={(option) => option}
              onChange={(event, value) => {
                handleFormEditChange("levelAccess", value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Level Access"
                  fullWidth
                  style={{ marginBottom: "16px" }}
                />
              )}
            />
            {formStateEdit.levelAccess === "Brand" && (
              <Autocomplete
                multiple
                options={brands}
                getOptionLabel={(option) => option.name}
                value={formStateEdit.selectedBrands}
                onChange={(event, newValue) => {
                  handleFormEditChange("selectedBrands", newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Level Access Brands"
                    fullWidth
                    style={{ marginBottom: "16px" }}
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      label={option.name}
                      {...getTagProps({ index })}
                      style={{ margin: "2px" }}
                    />
                  ))
                }
              />
            )}
            {/* Show Organizations dropdown if level access is 'organization' */}
            {formStateEdit.levelAccess === "Organization" && (
              <Autocomplete
                multiple
                value={formStateEdit.selectedOrganizations}
                options={organizations}
                getOptionLabel={(option) => option.name}
                onChange={(event, newValue) =>
                  handleFormEditChange("selectedOrganizations", newValue)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Level Access Organizations"
                    fullWidth
                    style={{ marginBottom: "16px" }}
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      label={option.name}
                      {...getTagProps({ index })}
                      style={{ margin: "2px" }}
                    />
                  ))
                }
              />
            )}
            <Autocomplete
              disabled={formStateEdit.reportType === "Existing"}
              options={channels}
              getOptionLabel={(option) => option.name}
              onChange={(event, value) =>
                handleFormEditChange("selectedChannel", value)
              }
              value={formStateEdit.selectedChannel}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Channel Name"
                  fullWidth
                  style={{ marginBottom: "16px" }}
                />
              )}
            />
            <Autocomplete
              options={modules}
              disabled={formStateEdit.reportType === "Existing"}
              getOptionLabel={(option) => option.name}
              onChange={(event, value) =>
                handleFormEditChange("selectedModule", value)
              }
              value={formStateEdit.selectedModule}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Module Name"
                  fullWidth
                  style={{ marginBottom: "16px" }}
                />
              )}
            />
            <Autocomplete
              disabled={formStateEdit.reportType === "Existing"}
              options={groupings.filter((g) =>
                formStateEdit.selectedChannel
                  ? g.channel_id === formStateEdit.selectedChannel.id
                  : g
              )}
              value={formStateEdit.selectedGroupings}
              getOptionLabel={(option) =>
                `${option.name}  (${channelMapping[option.channel_id]})`
              }
              onChange={(event, value) =>
                handleFormEditChange("selectedGroupings", value)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Grouping Name"
                  fullWidth
                  style={{ marginBottom: "16px" }}
                />
              )}
            />

            <Autocomplete
              options={component}
              disabled={
                !!formStateEdit.selectedReports?.find((sr: any) =>
                  sr?.embeded_url?.includes("tableau.com")
                )
              }
              value={formStateEdit.selectedUIComponents}
              getOptionLabel={(option) => option.name}
              onChange={(event, value) =>
                handleFormEditChange("selectedUIComponents", value)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select UI Component Name"
                  fullWidth
                  style={{ marginBottom: "16px" }}
                />
              )}
            />

            {formStateEdit.selectedUIComponents?.name == "SuperComponent" && (
              <Autocomplete
                disabled={formStateEdit.reportType === "Existing"}
                multiple
                options={customComponents}
                value={formStateEdit.selectedCustomComponents}
                getOptionLabel={(option) => option.name}
                onChange={(event, value) =>
                  handleFormEditChange("selectedCustomComponents", value)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Custom Component Name"
                    fullWidth
                    style={{ marginBottom: "16px" }}
                  />
                )}
              />
            )}

            <Box
              display="flex"
              justifyContent="flex-start"
              alignItems="center"
              style={{ marginBottom: "8px", marginTop: "8px" }}
            >
              <Info className="info-icon " fontSize="small" />
              <Typography
                variant="body2"
                color="textSecondary"
                style={{
                  marginLeft: 5,
                }}
              >
                If you want multiple reports, contact support.
              </Typography>
            </Box>

            <Label className="block mb-2">Select Report</Label>
            <MultiSelectCheckboxTag
              placeholder="Select reports"
              options={(reports || []).map((r: any) => ({ label: r?.display_name || String(r?.id ?? ''), value: String(r.id) }))}
              value={(formStateEdit.selectedReports || []).map((r: any) => String(r.id))}
              onChange={(ids: string[]) =>
                handleFormEditChange(
                  "selectedReports",
                  ids.map((id: string) => reports.find((r: any) => String(r.id) === id)).filter(Boolean) as any[]
                )
              }
              containerClassName="w-full"
              showSelectAll
            />

            <Autocomplete
              options={reportsSandbox}
              disabled={
                formStateEdit.reportType === "Existing" ||
                formStateEdit.selectedReports?.find((sr: any) =>
                  sr?.embeded_url?.includes("tableau.com")
                )
              }
              value={formStateEdit.selectedSandbox}
              getOptionLabel={(option) => `${option.display_name}`}
              onChange={(event, value) =>
                handleFormEditChange("selectedSandbox", value)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Sandbox"
                  fullWidth
                  style={{ marginBottom: "16px" }}
                />
              )}
            />
            <TextField
              disabled={formStateEdit.reportType === "Existing"}
              label="Route Endpoint"
              value={formStateEdit.routeEndPoint?.split("/").pop()}
              onChange={(e) =>
                handleFormEditChange("routeEndPoint", e.target.value)
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {createEndPoint(formStateEdit)}
                  </InputAdornment>
                ),
              }}
              fullWidth
              style={{ marginBottom: "16px" }}
            />

            {formStateEdit.selectedUIComponents?.name != "SuperComponent" ? (
              <TextField
                label="Params"
                value={formStateEdit.params}
                disabled={
                  formStateEdit.reportType === "Existing" ||
                  !!formStateEdit.selectedReports?.find((sr: any) =>
                    sr?.embeded_url?.includes("tableau.com")
                  )
                }
                onChange={(e) => handleFormEditChange("params", e.target.value)}
                fullWidth
                style={{ marginBottom: "16px" }}
              />
            ) : (
              <DynamicNestedForm
                formStateEdit={formStateEdit}
                handleFormEditChange={handleFormEditChange}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleEditDialogClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleEditSubmit} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openTeamChangeDialog}
          onClose={() => setOpenTeamChangeDialog(false)}
        >
          <DialogTitle>Confirm Team Access Change</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to make changes to this item's team access?
              This will cause other items present in the group to also change.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenTeamChangeDialog(false)}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                setFormStateEdit((prev: any) => ({
                  ...prev,
                  isTeam: !editTeamAcessCheck.current,
                }));
                setOpenTeamChangeDialog(false);
              }}
              color="primary"
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openTeamChangeDialog}
          onClose={() => setOpenTeamChangeDialog(false)}
        >
          <DialogTitle>Confirm Team Access Change</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to make changes to this item's team access?
              This will cause other items present in the group to also change.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenTeamChangeDialog(false)}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                setFormStateEdit((prev: any) => ({
                  ...prev,
                  isTeam: !editTeamAcessCheck.current,
                }));
                setOpenTeamChangeDialog(false);
              }}
              color="primary"
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    </>
  );
};

export default Items;
